module.exports = __webpack_public_path__ + "styles/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./styles/ajax-loader.gif
// module id = 56
// module chunks = 0